import {login,register,getVerifyCode,getImgYzm,forgetPassword,getDicInfo} from '@/api/kinds/login'
import {getResume,submitgetrs,saveResume,getPostInfo,getMyApplyInfo} from '@/api/kinds/applyFor'
import {outpatientQuestion,hospitalization} from '@/api/kinds/satisfaction'
export const api = {
    login,register,getVerifyCode,getImgYzm,forgetPassword,getDicInfo,
    getResume,submitgetrs,saveResume,getPostInfo,getMyApplyInfo,
    outpatientQuestion,hospitalization
}

export default {
    install(Vue) {
        Vue.prototype.$api = api;
    }
}